module.exports = __webpack_public_path__ + "static/img/Rory-Lobb.78c0402.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rory-Lobb.jpg
// module id = tUm9
// module chunks = 0